import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import willDestroy from "@ember/render-modifiers/modifiers/will-destroy";
import didUpdate from "@ember/render-modifiers/modifiers/did-update";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import discourseLater from "discourse/lib/later";
import { i18n } from "discourse-i18n";

export default class EditEnforce extends Component {
  @service enforceEditReason;
  @service composer;

  @tracked hasEditReason = false;
  @tracked getAttention = false;
  @tracked highlight = false;

  inputHandler = () => {
    if (this.inputElement?.value.trim()) {
      this.editReasonElement?.classList.remove("--danger");
      this.composer.set("disableSubmit", false);
      this.hasEditReason = true;
      this.getAttention = false;
      this.highlight = false;
    } else {
      this.hasEditReason = false;
      this.highlight = true;
      this.composer.set("disableSubmit", true);
    }
  };

  attentionHandler = () => {
    const button = this.createButtonElement;
    if (button?.classList.contains("disabled") || button?.disabled) {
      this.getAttention = true;
      this.highlight = true;

      discourseLater(() => {
        this.getAttention = false;
      }, 500);
    }
  };

  get editReasonElement() {
    return document.querySelector(".display-edit-reason");
  }

  get inputElement() {
    return document.getElementById("edit-reason");
  }

  get createButtonElement() {
    return document.querySelector(".create");
  }

  get shouldShow() {
    return this.enforceEditReason.enforceReason;
  }

  @action
  setupListeners() {
    this._inputElement = this.inputElement;
    this._createButtonElement = this.createButtonElement;

    this._inputElement?.addEventListener("input", this.inputHandler);
    this._createButtonElement?.addEventListener(
      "pointerdown",
      this.attentionHandler,
    );
  }

  @action
  cleanupListeners() {
    this._inputElement?.removeEventListener("input", this.inputHandler);
    this._createButtonElement?.removeEventListener(
      "pointerdown",
      this.attentionHandler,
    );
  }

  @action
  resetState() {
    this.enforceEditReason.toggleState(false);
  }

  <template>
    {{#if this.shouldShow}}
      <div
        class="edit-enforcer
          {{unless this.hasEditReason '--danger'}}
          {{if this.getAttention '--animate'}}
          {{if this.highlight '--highlight'}}"
        {{didInsert this.setupListeners}}
        {{willDestroy this.cleanupListeners}}
        {{didUpdate
          this.resetState
          this.enforceEditReason.composerModel.action
        }}
      >
        {{#if this.hasEditReason}}
          {{dIcon "check"}}
        {{else}}
          {{dIcon "triangle-exclamation"}}
          {{i18n "form_kit.errors.required"}}
        {{/if}}
      </div>
    {{/if}}
  </template>
}
